//@flow
import BodyView from "./BodyView"

export default BodyView



// WEBPACK FOOTER //
// ./src/Kiosk/BodyView/index.js